import { TAuthTokens } from './types';

const CHANNEL_NAME = 'eas-cc-auth';

type TTabMessage = { type: 'tokens'; tokens: TAuthTokens } | { type: 'signed-out' };

type TTabSyncHandlers = {
	onTokens: (tokens: TAuthTokens) => void;
	onSignedOut: () => void;
};

const channel: BroadcastChannel | null =
	typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL_NAME);

export const tabSync = {
	listen: (handlers: TTabSyncHandlers): void => {
		if (!channel) return;
		channel.onmessage = (event: MessageEvent<TTabMessage>) => {
			if (event.data?.type === 'tokens') handlers.onTokens(event.data.tokens);
			if (event.data?.type === 'signed-out') handlers.onSignedOut();
		};
	},

	publishTokens: (tokens: TAuthTokens): void => {
		channel?.postMessage({ type: 'tokens', tokens } satisfies TTabMessage);
	},

	publishSignedOut: (): void => {
		channel?.postMessage({ type: 'signed-out' } satisfies TTabMessage);
	},
};
